<section id="screenshots" class="screenshot-area ptb-100">
    <div class="container-fluid">
        <div class="section-title">
            <h2>Unsere erfolgreichen Fahrschüler</h2>
            <div class="bar"></div>
            <p>Hier siehst du eine Auswahl an glücklichen Absolventen, die ihren Führerschein erfolgreich mit Tommys Fahrschule bestanden haben. Wir sind stolz auf jeden Einzelnen!</p>
        </div>

        <div class="screenshot-slider owl-carousel owl-theme">
            <!-- Bilder von bild2.jpg à bild15.jpg -->
            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild2.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild3.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild4.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild5.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild6.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild8.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild9.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild10.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild12.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild13.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild14.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>

            <div class="screenshot-item">
                <div class="image">
                    <img src="assets/img/erfolg/bild15.jpg" alt="Erfolgreicher Fahrschüler">
                </div>
            </div>
        </div>
    </div>
</section>
